import useSavedViewCleaner from '@/composables/saved-views/saved-view-cleaner';
import { computed, ref } from 'vue';
import { copy } from 'shared/lib/copy';

export default function useDefaultView(
  defaultView,
  defaultProps,
  viewApplication,
  space,
  planning,
  user,
  loggedInUser,
  loggedInUserAccount,
  gridPageTile,
  repo,
  viewCollection,
) {
  const { clearView } = useSavedViewCleaner();

  const buildDefaultView = (view) => clearView({
    view: {
      uid: 0,
      goalSort: [],
      emoji: '',
      ...copy(view),
      isTemp: true,
      creator: { uid: loggedInUser.value.uid },
      account: { uid: loggedInUserAccount.value.uid },
      viewApplication,
      space,
      planning,
      user,
      gridPageTile,
    },
    props: defaultProps.value,
  });

  const defaultViewCopy = buildDefaultView(defaultView);
  const defaultViewLocal = ref(copy(defaultViewCopy));

  const views = computed(() => {
    if (repo.views.value.length === 0) {
      return [defaultViewLocal.value];
    }

    return repo.views.value;
  });

  const createViews = (views, viewOrder) => repo.createViews(views.map((v) => buildDefaultView(v)), viewOrder);

  const updateView = (view, options, hookParameter) => {
    if (view.isTemp) {
      const v = views.value.find((v) => v.uid === view.uid);
      if (v === undefined) {
        throw new Error(`Expected to find a view with id: ${view.uid}`);
      }
      return repo.createViews([{ ...v, ...view }], viewCollection.value).then((views) => views[0]);
    }
    return repo.updateView(view, options, hookParameter);
  };

  return {
    createLoading: repo.createLoading,
    createViews,

    loadingUpdateView: repo.loadingUpdateView,
    updateView,

    loadingDeleteView: repo.loadingDeleteView,
    deleteView: repo.deleteView,

    views,
  };
}
